import * as React from 'react';

import { Select } from 'antd';
import {Field} from 'formik';

import '@app/scss/localCommon/components/customAutoTokenization.scss';

const { Option } = Select;

const CustomAutoTokenization = ({name, placeholder, onChange}) => {
	return (
		<Field 
			name={name}
			
			render={(field) => {
				return(
					<div
						className={field.form.errors[name] && field.form.touched[name] ?
						'custom-field custom-input custom-tokenization error' :
						'custom-field custom-input custom-tokenization'}
			>
						<Select
							dropdownClassName={'custom-tokenization__dropdown'}
							mode="tags" 
							tokenSeparators={[',', ' ', ';']}
							placeholder={placeholder}
							open={false}
							onChange={onChange}
							onBlur={() => field.form.setFieldTouched(name, true)}
						/>
						{
							field.form.errors[name] ?
								<div className="custom-input__error"> {field.form.errors[name].filter(item => item)[0]}</div> :
								null
						}
					</div>
				);
			}}
		/>
		
	);
};

export default CustomAutoTokenization;